<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <span @click="watchingear0">微剧场</span>
      <span>></span>
      <router-link to>上传视频</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">上传视频</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>“微剧场”
          模块所上传的最终结果会根据您所排列的顺序及点读分段展现在小程序的微剧场功能部分。
        </div>
        <div class="form_1">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" />
              </i>
              <el-input v-model="form.name" placeholder="" :disabled="this.show" @blur="blur" @keyup.enter.native="$event.target.blur">
              </el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter1">
                  重命名
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="序号" prop="seqnum">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" />
              </i>
              <el-input v-model="form.seqnum" placeholder="输入序号 (阿拉伯数字)" :disabled="this.show1" @blur="blur_seq" @keyup.enter.native="$event.target.blur">
              </el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter2">
                  重置
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="上传视频" class="shangchuan_bg1" prop="orgcode">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.orgcode" placeholder="请输入您上传的视频名称" @keyup.enter.native="handleAvatarSuccess"></el-input>
              <el-upload class=" shangchuan_yinyue" action="#" accept=".mp4" :show-file-list="false" :disabled="disabled1"
                :http-request="handleAvatarSuccess">
                <el-button type="primary" class="my-10" @click="daoru_add">
                  导入视频
                </el-button>
              </el-upload>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg weijuchang">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column prop="title" label="视频名称" align="center">
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row }} -->
                        <input type="text" class="yp_name" :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'" v-model="scope1.row.title"
                          :disabled="scope1.row.selected" :id="scope1.row.selected ? '' : 'inputId'" @blur="blur1(scope1.$index, tableData)"
                          @keyup.13="blur1(scope1.$index, tableData)" />
                      </template>
                    </el-table-column>
                    <el-table-column label="视频排序" width="200">
                      <template slot-scope="scopes">
                        <el-input v-model="scopes.row.seqnum" class="yp_paixu" @blur="blur1(scopes.$index, tableData)" @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center">
                      <template slot-scope="stData">
                        <el-button type="text" @click="chong(stData.$index, tableData)">
                          重命名
                        </el-button>
                        <el-button type="text" @click="zhizuo_py(stData.row)">
                          编辑视频
                        </el-button>
                        <el-button type="text" @click="updatePhoto(stData.row.id)">
                          上传封面
                        </el-button>
                        <el-button type="text" @click="deleteListen(stData.row.id)">
                          删除视频
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="dialogStyle">
      <el-dialog title="上传封面" :visible.sync="dialogTableVisible" width="600px">
        <el-form ref="uploadForm" :model="uploadForm" :rules="uploadFormRules">
          <el-form-item prop="videoCover" label="上传封面" label-width="180" class="dz-flex">
            <div class="uploadPhoto">
              <el-upload v-model="uploadForm.videoCover" accept="image/png,image/jpg,image/jpeg" action="#" :show-file-list="false"
                :http-request="uploadPhoto" :before-upload="beforeAvatarUpload">
                <el-button type="primary" class="xinjian_fd">
                  更换封面
                </el-button>
              </el-upload>
              <img :src="uploadForm.videoCover" alt="">
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitUpdate">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const uploadFormRules = {
  videoCover: [{ required: true, message: '请选择视频封面!', trigger: 'blur' }],
};

export default {
  name: 'watchingear',
  data() {
    return {
      uploadFormRules,
      uploadForm: {
        videoCover: '',
      },
      form: {
        name: '',
        orgcode: '',
        seqnum: '',
      },
      show: true,
      show1: true,
      disabled1: true,
      FormRules: {},
      tempImg: '',
      banji_id: {},
      tableData: [],
      gh_yp: '',
      videoSrc: '',
      dialogTableVisible: false,
      videoId: '',
    };
  },
  created() {
    if (!this.$store.state.watching) {
      this.$router.push({ name: 'watching' });
      return this.$message.error('您当前的章节数据获取失败！');
    }
    this.banji_id = this.$store.state.watching;

    this.selectListeningList();
    this.selctChapterandsectionById();
  },
  destroyed() {
    localStorage.removeItem('watching');
  },
  watch: {},
  methods: {
    // 修改视频封面
    updatePhoto(id) {
      this.uploadForm.videoCover = '';
      this.videoId = id;
      // 查询视频封面
      this.getVideoPic();
      this.dialogTableVisible = true;
    },
    getVideoPic() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/watch/selectCover?watchId=' + this.videoId,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.uploadForm.videoCover = result.data.data;
        })
        .catch((err) => {
          return this.$message.error('查询视频封面失败：' + err);
        });
    },
    beforeAvatarUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isLt1M) {
        this.$message.error('上传头像图片大小不能超过 1MB!');
      }
      return isLt1M;
    },
    uploadPhoto(file) {
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success('更换封面成功！');
          this.uploadForm.videoCover = result.data.data;
        })
        .catch((err) => {
          this.$message.error('更换错误：' + err);
        });
    },
    // 确认修改封面
    submitUpdate() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/watch/editCover',
        method: 'POST',
        data: {
          videoId: this.videoId,
          coverUrl: this.uploadForm.videoCover,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.dialogTableVisible = false;
          return this.$message.success('封面修改成功！');
        })
        .catch((err) => {
          return this.$message.error('封面修改失败：' + err);
        });
    },
    watchingear0() {
      this.$store.commit('watchingear0', this.banji_id.bookid);
      this.$router.push({ name: 'watching' });
    },
    // 编辑视频
    zhizuo_py(watchingear) {
      // console.log(this.banji_id)
      // console.log(watchingear)
      this.$store.commit('watchingear', watchingear);
      this.$store.commit('watchingears', this.banji_id);
      this.$router.push({ name: 'watchingDubList' });
    },

    // 章节重命名
    updateChapter1() {
      this.show = false;
    },
    updateChapter2() {
      this.show1 = false;
    },
    blur() {
      this.show = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          title: this.form.name,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('章节重命名成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('章节重命名失败：' + err);
        });
    },
    blur_seq() {
      this.show1 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          seqnum: this.form.seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('序号重置成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('序号重置失败：' + err);
        });
    },
    // 视频重命名
    chong(index, rows) {
      // console.log(index)
      // console.log(rows[index])
      rows[index].selected = false;
      document.getElementById('inputId').focus();
      // this.$refs.id.focus()
    },
    blur1(index, rows) {
      // console.log(rows[index])
      rows[index].selected = true;

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/watch/updateWatch',
        method: 'POST',
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectListeningList();
          return this.$message.success('视频修改成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('视频修改失败：' + err);
        });
    },

    // 上传视频
    handleAvatarSuccess(data) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: '#ffffff',
      });
      let formData = new FormData();
      formData.append('video', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadVideo',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success('上传视频成功！');
          this.videoSrc = result.data.data;
          this.addVideo();
          loading.close();
        })
        .catch((err) => {
          this.$message.error('上传视频错误：' + err);
        });
    },
    // 新增视频
    addVideo() {
      let orgid = window.sessionStorage.getItem('orgid');
      let data = {
        title: this.form.orgcode,
        video_url: this.videoSrc,
        orgid: orgid,
        bookid: this.banji_id.bookid,
        chapterid: this.banji_id.id,
      };
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');

      let pro = this.$http({
        url: '/edu/watch/addWatch',
        method: 'POST',
        data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.orgcode = '';
          this.selectListeningList();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询视频列表失败：' + err);
        });
    },
    daoru_add() {
      if (this.form.orgcode === '') {
        this.disabled1 = true;
        return this.$message.error('请首先输入该视频的名称！');
      } else {
        this.disabled1 = false;
      }
    },

    // 删除视频
    deleteListen(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/watch/deleteWatch?watchId=' + id,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectListeningList();
            return this.$message.success('删除视频成功!');
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('删除视频失败：' + err);
          });
      });
    },

    // 查询章节名称
    selctChapterandsectionById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/chapterandsection/selctChapterandsectionById/' + this.banji_id.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.name = result.data.data.title;
          this.form.seqnum = result.data.data.seqnum;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询章节名称失败：' + err);
        });
    },

    // 查询视频列表
    selectListeningList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/watch/selectWatchList',
        method: 'POST',
        data: {
          bookid: this.banji_id.bookid,
          chapterid: this.banji_id.id,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询视频列表失败：' + err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
audio:focus {
  outline: none;
}
.yp_paixu {
  input {
    width: 44px !important;
    height: 25px !important;
  }
  .el-input__inner {
    padding: 0 !important;
    margin: 0 !important;
    margin: 0 auto;
    text-align: center;
  }
}
.yp_name {
  margin-left: 0 !important;
  font-size: 16px;
  color: #666;
  width: 140px !important;
  height: 1.6vw !important;
  padding-left: 10px;
  background: none;
  position: relative;
  left: -10px;
  border: none;
}
.yp_name1 {
  border: #00a6e6 1px solid;
}
.yp_name2 {
  border: none;
}
.yp_name:focus {
  border: #00a6e6 1px solid;
  outline: none;
}

.shangchuan_bg1 {
  margin: 0 !important;
}
.shangchuan_bg {
  margin: 0 !important;
  .el-form-item__content {
    margin: 0 !important;
    .grid-content {
      padding: 0 0.6vw;
      .zsbg {
        margin: 0 0 45px 0;
        .el-table th {
          background: #f7f7f7;
        }
      }
    }
  }
}
/deep/.el-dialog__title {
  border-left: 4px solid #0090c9;
  padding-left: 5px;
}
.uploadPhoto {
  padding: 0 0 0 25px;
  /deep/.el-upload {
    height: 28px;
  }
  img {
    margin: 20px 0;
    width: 360px;
    height: 202px;
  }
}
</style>
